import React, { useMemo } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  Divider,
  Box,
} from "@material-ui/core";
import dayjs from "dayjs";
import "dayjs/locale/es";
dayjs.locale("es");

const ModalEstadisticasRecaudacion = ({
  isOpen,
  setOpen,
  fechaInicio,
  fechaTermino,
  datosRecaudacion,
  cargandoDatos,
}) => {
  const handleClose = () => {
    setOpen(false);
  };

  const periodoTexto = `${dayjs(fechaInicio, "YYYY/MM").format("MMMM YYYY")} - ${dayjs(fechaTermino, "YYYY/MM").format("MMMM YYYY")}`;

  const totalRecaudado = datosRecaudacion?.recaudadoTotalMes || 0;
  const historicoGrafico = datosRecaudacion?.recaudadoGrafico || [];

  const historicoFiltrado = useMemo(() => {
    if (!fechaInicio || historicoGrafico.length === 0) {
      return historicoGrafico;
    }

    const fechaInicioLimite = dayjs(fechaInicio, "YYYY/MM").startOf("month");

    return historicoGrafico.filter((item) => {
      if (!item.fecha) return false;

      const fechaOriginal = item.fecha.toString().trim().toLowerCase();

      let fechaItem = dayjs(fechaOriginal, "YYYY-MMMM", "es");

      if (!fechaItem.isValid()) {
        fechaItem = dayjs(fechaOriginal.replace(/-/g, "/"));
      }

      if (!fechaItem.isValid()) {
        fechaItem = dayjs(fechaOriginal);
      }

      if (!fechaItem.isValid()) {
        return true;
      }

      const inicioMesItem = fechaItem.startOf("month");

      return (
        inicioMesItem.isAfter(fechaInicioLimite) ||
        inicioMesItem.isSame(fechaInicioLimite)
      );
    });
  }, [historicoGrafico, fechaInicio]);

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="dialog-modal-estadisticas-recaudacion"
      id="dialog-modal-estadisticas-recaudacion"
      fullWidth
      maxWidth="md"
    >
      <DialogTitle id="dialog-modal-estadisticas-recaudacion-titulo">
        <Box display="flex" flexDirection="column">
          <Typography
            variant="h5"
            component="span"
            style={{ textTransform: "capitalize" }}
          >
            Detalle de Ingresos y Recaudación Real
          </Typography>
          <Typography
            variant="subtitle2"
            color="textSecondary"
            style={{ textTransform: "capitalize" }}
          >
            Período: {periodoTexto}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent dividers>
        {cargandoDatos ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="200px"
          >
            <Typography variant="body1">
              Cargando estadísticas de ingresos...
            </Typography>
          </Box>
        ) : (
          <Grid container spacing={3}>
            {/* Tarjeta de Resumen Rápido */}
            <Grid item xs={12} md={5}>
              <Box
                p={3}
                border={1}
                borderColor="divider"
                borderRadius={2}
                bgcolor="background.paper"
              >
                <Typography
                  variant="overline"
                  color="textSecondary"
                  display="block"
                  gutterBottom
                >
                  Total Recaudado del Período
                </Typography>
                <Typography
                  variant="h3"
                  color="primary"
                  style={{ fontWeight: "bold" }}
                >
                  ${totalRecaudado.toLocaleString("es-CL")}
                </Typography>
                <Divider style={{ margin: "16px 0" }} />
                <Typography variant="body2" color="textSecondary">
                  Monto que efectivamente ha ingresado a caja en las sucursales
                  seleccionadas para el rango visualizado.
                </Typography>
              </Box>
            </Grid>

            {/* Desglose de Fechas y Montos Filtrados */}
            <Grid item xs={12} md={7}>
              <Typography
                variant="subtitle1"
                gutterBottom
                style={{ fontWeight: "bold" }}
              >
                Desglose por Fechas de Pago (Filtrado)
              </Typography>
              <Box
                p={2}
                border={1}
                borderColor="divider"
                borderRadius={2}
                style={{ maxHeight: "300px", overflowY: "auto" }}
              >
                {historicoFiltrado.length > 0 ? (
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr
                        style={{
                          textAlign: "left",
                          borderBottom: "2px solid #e0e0e0",
                        }}
                      >
                        <th
                          style={{
                            padding: "8px",
                            color: "#757575",
                            fontSize: "0.85rem",
                          }}
                        >
                          Fecha
                        </th>
                        <th
                          style={{
                            padding: "8px",
                            textAlign: "right",
                            color: "#757575",
                            fontSize: "0.85rem",
                          }}
                        >
                          Monto Cobrado
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {historicoFiltrado.map((item, index) => (
                        <tr
                          key={index}
                          style={{ borderBottom: "1px solid #f0f0f0" }}
                        >
                          <td
                            style={{
                              padding: "10px 8px",
                              fontSize: "0.9rem",
                              textTransform: "capitalize",
                            }}
                          >
                            {item.fecha}
                          </td>
                          <td
                            style={{
                              padding: "10px 8px",
                              textAlign: "right",
                              fontWeight: "bold",
                              fontSize: "0.9rem",
                            }}
                          >
                            ${item.total?.toLocaleString("es-CL")}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    minHeight="150px"
                  >
                    <Typography variant="body2" color="textSecondary">
                      No se registran recaudaciones posteriores a la fecha{" "}
                      {fechaInicio}.
                    </Typography>
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ModalEstadisticasRecaudacion;
